import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import Radio from "./Radio";

import s from '../../Cliente/contacto.module.scss';


const List = ({ field, form, label, labelPosition, items, bootstrapCol, disabled, error }) => {

    const [selectedItem, setSelectedItem] = useState(field.value);

    let csChild = '';
    let csParent = 'pretty_radio_list_wrapper';

    useEffect(() => {
        setSelectedItem(field.value)
    }, [field.value])

    const handleChange = (e) => {
        form.setFieldValue(field.name, e);
        setSelectedItem(e);
    }

    if (error) {
        csParent = csParent + ' is-required';
        csChild = csChild + ' is-invalid';
    }

    return <div className={csParent}>
        {label && <label >{label}</label>}
        <div className={`${csChild + s.flex} `}>
            {items.map((item, index) =>
                <div className={items.length > 2 ? s.pretty_radio_list_col_3 : s.pretty_radio_list_col_2} key={index}>
                    <Radio
                        key={index}
                        item={item}
                        labelPosition={labelPosition}
                        checked={item.value === selectedItem}
                        onChange={(e) => handleChange(e)}
                        name={field.name}
                        disabled={disabled !== undefined ? disabled : false}
                    />
                </div>
            )}
        </div>
        <ErrorMessage name={field.name} className={s.errorField} component="div" />
    </div>
}

List.propTypes = {
    items: PropTypes.array.isRequired,
    label: PropTypes.string,
    labelPosition: PropTypes.string,
    //numero de columnas de bootstrap para lg
    bootstrapCol: PropTypes.number,
}

export default List;
